"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactRedux = require("react-redux");

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

var _MobilitySelector = require("../../components/steps/MobilitySelector");

var _MobilitySelector2 = _interopRequireDefault(_MobilitySelector);

var _service = require("../../actions/service");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadServices: function loadServices(garageId) {
      dispatch((0, _service.loadServices)(garageId));

      _reactGa2.default.set({
        "dimension1": garageId
      });

      _reactGa2.default.event({
        category: "OTB",
        action: "Step",
        label: "Mobility"
      });
    }
  };
}

function mapStateToProps(state) {
  var formData = state.formData,
      service = state.service,
      global = state.global,
      garage = state.garage;
  var garageId = formData.garageId,
      mobilityIds = formData.mobilityIds;
  var mobilitys = garage.garages[garageId].MobilityOptions;
  return {
    garageId: garageId,
    mobilitys: mobilitys,
    mobilityIds: mobilityIds
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

var MobilitySelectionContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(_MobilitySelector2.default);
exports.default = MobilitySelectionContainer;